import React from 'react';
import './Home.css';

const Home = () => {
  const currentUrl = window.location.origin;
  const callbackUrl = `${currentUrl}/auth/callback`;

  const handleTestMode = () => {
    // Simulate OAuth callback with test parameters
    const testUrl = `/auth/callback?code=test_code_12345&state=test_provider`;
    window.location.href = testUrl;
  };

  return (
    <div className="home-container">
      <div className="home-card">
        <h1 className="home-title">EBM Safari OAuth Bridge</h1>
        <p className="home-description">
          Frontend React application for handling OAuth callbacks for the EBM Safari extension.
        </p>

        <div className="info-section">
          <h2>OAuth Callback Endpoint</h2>
          <div className="endpoint-info">
            <code className="endpoint-url">{callbackUrl}</code>
            <p className="endpoint-description">
              Configure this URL as your OAuth redirect URI in your OAuth provider settings.
            </p>
          </div>
        </div>

        <div className="info-section">
          <h2>How it works</h2>
          <ul className="feature-list">
            <li>Receives OAuth callback with <code>code</code> and <code>state</code> parameters</li>
            <li>Processes callback completely invisibly (no UI flash)</li>
            <li>Redirects immediately to Safari extension with OAuth data</li>
            <li>Supports dynamic extension ID via state parameter</li>
            <li>Fallback to hardcoded extension ID if needed</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>Configuration</h2>
          <div className="config-info">
            <p><strong>Current Domain:</strong> <code>{currentUrl}</code></p>
            <p><strong>Callback Route:</strong> <code>/auth/callback</code></p>
            <p><strong>Extension Protocol:</strong> <code>safari-web-extension://</code></p>
          </div>
        </div>

        <div className="test-section">
          <h2>Test Mode</h2>
          <p>Click the button below to simulate an OAuth callback and test the redirect flow:</p>
          <button 
            className="test-button"
            onClick={handleTestMode}
          >
            Test OAuth Callback
          </button>
        </div>

        <div className="footer-info">
          <p>This is a frontend-only React application. No backend server required.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
